import calculateQuote from './calculate.mjs'
import { calculateActivationTotalForProduct } from './calculateActivationTotalForProduct.mjs'

//TODO: We should probably just have the proration calculations add a "proratedTotal" field to the monthly prices
export function calculateActivationItemTotals(
   // Required inputs to perform a calculation.
   product_list,
   discount_list,
   book_id,
   quoteType,
   coreProductSelected,
   productCoreEECount,
   productPerformanceEECount,
   productTimeTrackingEECount,
   hasTimeClocks,
   productTimeClockDetails,
   productBenefitsAdministrationEECount,
   productPayrollEINCount,
   productPayrollEECount,
   productPayrollEECounts,
   productPayrollTotalStateCount,
   productPayrollStateCounts,
   professionalServiceDetails,
   consultingServiceDetails,
   impType,
   benAdminImpType,
   payrollImpType,
   discountBundle,
   discountNonProfit,
   prepayLength,
   discountMultiEntity,
   discountHRMonthlyPromotion,
   discountHRDealDeskMonthly,
   discountReseller,
   discountQuickstartTraining,
   discountImpPromotion,
   discountDealDeskHRImp,
   discountDealDeskPayrollImp,
   discountSecondEIN,
   discountGroupImp,
   discountDealDeskHRImpRate,
   discountDealDeskQuickstartImpRate,
   discountDealDeskPayrollImpRate,
   productAdditionalStorageCount,
   productAdditionalJobsCount,
   productHistoricalDataImport,
   productMarketplaceListing,
   productSponsorship,
   productPaidServiceAmount,
   productTestAccount,
   activationDate, // if not supplied, defaults to 1st day of month
   differenceQuote,
   accountSnowflake,
   coreCountryCount,
   promotionalDiscounts,
   nextInvoiceDate,
   currencyObject,
   accountBalance,
   monthlyTax,
   productEINIntegrations,
   allPermissions,
   user_role,
   account_status,
   pricebookDetails,
   previousCurrencyObject,
   productPayrollEINImpTypes,
   prepaymentActivationUseDifference,
   dynamicProducts,
   selectedTimeProduct = 'timeTracking',
   isATSOnly = false,
   isRecalculation = false,
) {
   // Normalize dynamicProducts to a Map. It may arrive as an array of tuples or
   // a plain object from serialized state; downstream code expects a Map.
   if (!(dynamicProducts instanceof Map)) {
      if (Array.isArray(dynamicProducts)) {
         dynamicProducts = new Map(dynamicProducts)
      } else if (dynamicProducts && typeof dynamicProducts === 'object') {
         dynamicProducts = new Map(Object.entries(dynamicProducts))
      } else {
         dynamicProducts = new Map()
      }
   }

   //Create a Tuple of all the parameters to pass to the calculateQuote function
   // This is a workaround to avoid passing too many parameters directly.
   const calculateParams = [
      product_list,
      discount_list,
      book_id,
      quoteType,
      coreProductSelected,
      productCoreEECount,
      productPerformanceEECount,
      productTimeTrackingEECount,
      hasTimeClocks,
      productTimeClockDetails,
      productBenefitsAdministrationEECount,
      productPayrollEINCount,
      productPayrollEECount,
      productPayrollEECounts,
      productPayrollTotalStateCount,
      productPayrollStateCounts,
      professionalServiceDetails,
      consultingServiceDetails,
      impType,
      benAdminImpType,
      payrollImpType,
      discountBundle,
      discountNonProfit,
      prepayLength,
      discountMultiEntity,
      discountHRMonthlyPromotion,
      discountHRDealDeskMonthly,
      discountReseller,
      discountQuickstartTraining,
      discountImpPromotion,
      discountDealDeskHRImp,
      discountDealDeskPayrollImp,
      discountSecondEIN,
      discountGroupImp,
      discountDealDeskHRImpRate,
      discountDealDeskQuickstartImpRate,
      discountDealDeskPayrollImpRate,
      productAdditionalStorageCount,
      productAdditionalJobsCount,
      productHistoricalDataImport,
      productMarketplaceListing,
      productSponsorship,
      productPaidServiceAmount,
      productTestAccount,
      activationDate, // if not supplied, defaults to 1st day of month
      differenceQuote,
      accountSnowflake,
      coreCountryCount,
      promotionalDiscounts,
      nextInvoiceDate,
      currencyObject,
      accountBalance,
      monthlyTax,
      productEINIntegrations,
      allPermissions,
      user_role,
      account_status,
      pricebookDetails,
      previousCurrencyObject,
      productPayrollEINImpTypes,
      prepaymentActivationUseDifference,
      dynamicProducts,
      selectedTimeProduct,
      isATSOnly,
   ]

   let proratedCoreTotal = 0,
      proratedBenefitsTotal = 0,
      proratedMonthlyTaxTotal = 0,
      proratedPerformanceTotal = 0,
      proratedTimeTrackingTotal = 0,
      proratedTimeAttendanceTotal = 0,
      impTotalsPrice = 0,
      payrollImplementationTotal = 0,
      historicalDataImportTotal = 0,
      marketplaceListingTotal = 0,
      sponsorshipTotal = 0,
      proratedAdditionalJobsTotal = 0,
      proratedAdditionalStorageTotal = 0,
      testAccountTotal = 0,
      paidServicesTotal = 0,
      timeClocksTotal = 0,
      consultingServicesTotal = 0,
      accountBalanceTotal = 0,
      dynamicProductTotals = new Map()

   // Explicitly type the calculatedValues returned by calculateQuote as CalculatedValues.
   const calculatedValues = calculateQuote(
      ...calculateParams,
      isRecalculation,
   )

   // Calculate prorated total for core services if available, otherwise default to 0.
   proratedCoreTotal = calculateActivationTotalForProduct(
      calculatedValues.productCoreMonthlyCosts,
      ...calculateParams,
      null, // monthsToCalculate
      true, // includeProrated
      false, // forceIncludeBundle
   )

   // Calculate prorated total for benefits administration if available, otherwise default to 0.
   proratedBenefitsTotal = calculateActivationTotalForProduct(
      calculatedValues.productBenefitsAdministrationMonthlyCosts,
      ...calculateParams,
      null, // monthsToCalculate
      true, // includeProrated
      false, // forceIncludeBundle
   )

   // Calculate prorated total for monthly tax costs if available, otherwise default to 0.
   proratedMonthlyTaxTotal = calculateActivationTotalForProduct(
      calculatedValues.MonthlyTaxCosts,
      ...calculateParams,
      null, // monthsToCalculate
      true, // includeProrated
      false, // forceIncludeBundle
   )

   // Calculate prorated total for performance-related services if available, otherwise default to 0.
   proratedPerformanceTotal = calculateActivationTotalForProduct(
      calculatedValues.productPerformanceMonthlyCosts,
      ...calculateParams,
      null, // monthsToCalculate
      true, // includeProrated
      false, // forceIncludeBundle
   )

   // Calculate prorated total for time tracking services if available, otherwise default to 0.
   proratedTimeTrackingTotal = calculateActivationTotalForProduct(
      calculatedValues.productTimeTrackingMonthlyCosts,
      ...calculateParams,
      null, // monthsToCalculate
      true, // includeProrated
      false, // forceIncludeBundle
   )

   // Calculate prorated total for time attendance services if available, otherwise default to 0.
   proratedTimeAttendanceTotal = calculateActivationTotalForProduct(
      calculatedValues.productTimeAttendanceMonthlyCosts,
      ...calculateParams,
      null, // monthsToCalculate
      true, // includeProrated
      false, // forceIncludeBundle
   )

   // Calculate the implementation totals price by adding HR implementation and benefits administration costs.
   impTotalsPrice =
      calculatedValues.hrImplementationCosts?.totalPriceDifference +
      calculatedValues.productBenefitsAdministrationMonthlyCosts?.totalPrice

   // Get payroll implementation total if available, otherwise default to 0.
   payrollImplementationTotal = calculatedValues.payrollImplementationTotalCosts
      ?.totalPrice
      ? calculatedValues.payrollImplementationTotalCosts.totalPrice
      : 0

   // Get historical data import total if available, otherwise default to 0.
   historicalDataImportTotal = calculatedValues.HistoricalDataImportCosts
      ?.totalPrice
      ? calculatedValues.HistoricalDataImportCosts.totalPrice
      : 0

   // Get marketplace listing total if available, otherwise default to 0.
   marketplaceListingTotal = calculatedValues.MarketplaceListingCosts
      ?.totalPrice
      ? calculatedValues.MarketplaceListingCosts.totalPrice
      : 0

   // Get sponsorship total if available, otherwise default to 0.
   sponsorshipTotal = calculatedValues.SponsorshipCosts?.totalPrice
      ? calculatedValues.SponsorshipCosts.totalPrice
      : 0

   // Get paid services total if available, otherwise default to 0.
   paidServicesTotal = calculatedValues.PaidServiceCosts?.totalPrice
      ? calculatedValues.PaidServiceCosts.totalPrice
      : 0

   // Get account balance total if available, otherwise default to 0.
   accountBalanceTotal = calculatedValues.AccountBalanceCosts?.totalPrice ?? 0

   // Calculate prorated total for additional job postings if available, otherwise default to 0.
   proratedAdditionalJobsTotal = calculateActivationTotalForProduct(
      calculatedValues.AdditionalJobsCosts,
      ...calculateParams,
      null, // monthsToCalculate
      true, // includeProrated
      false, // forceIncludeBundle
   )

   // Calculate prorated total for additional storage if available, otherwise default to 0.
   proratedAdditionalStorageTotal = calculateActivationTotalForProduct(
      calculatedValues.AdditionalStorageCosts,
      ...calculateParams,
      null, // monthsToCalculate
      true, // includeProrated
      false, // forceIncludeBundle
   )

   // Get test account total if available, otherwise default to 0.
   testAccountTotal = calculateActivationTotalForProduct(
      calculatedValues.TestAccountCosts,
      ...calculateParams,
      null, // monthsToCalculate
      true, // includeProrated
      false, // forceIncludeBundle
   )

   // Calculate timeClock monthly amount (never prorated)
   timeClocksTotal = calculateActivationTotalForProduct(
      calculatedValues.TimeClockMonthlyCost,
      ...calculateParams,
      null, // monthsToCalculate
      true, // includeProrated
      false, // forceIncludeBundle
   )

   // Calculate timeClock monthly amount (never prorated)
   for (const service of calculatedValues.ConsultingServicesCosts) {
      consultingServicesTotal += calculateActivationTotalForProduct(
         service,
         ...calculateParams,
         null, // monthsToCalculate
         true, // includeProrated
         false, // forceIncludeBundle
      )
   }
   // Calculate dynamic product totals - only for products with IncludeInActivation = true
   for (const [productCode, value] of dynamicProducts?.entries() ?? []) {
      const product = product_list[productCode] ?? null
      if (
         product &&
         productCode in calculatedValues?.selectedProductCosts &&
         product.IncludeInActivation
      ) {
         dynamicProductTotals.set(
            productCode,
            calculateActivationTotalForProduct(
               calculatedValues.selectedProductCosts[productCode],
               ...calculateParams,
               null, // monthsToCalculate
               true, // includeProrated
               false, // forceIncludeBundle
            ),
         )
      }
   }

   // Return an object containing all calculated prorated totals.
   return {
      proratedCoreTotal,
      proratedBenefitsTotal,
      proratedMonthlyTaxTotal,
      proratedPerformanceTotal,
      proratedTimeTrackingTotal,
      proratedTimeAttendanceTotal,
      impTotalsPrice,
      payrollImplementationTotal,
      historicalDataImportTotal,
      marketplaceListingTotal,
      sponsorshipTotal,
      proratedAdditionalJobsTotal,
      proratedAdditionalStorageTotal,
      testAccountTotal,
      paidServicesTotal,
      timeClocksTotal,
      consultingServicesTotal,
      accountBalanceTotal,
      dynamicProductTotals,
   }
}
